import {graphql, useStaticQuery} from 'gatsby';
import {resolveBrandLogoResource} from 'microsites/core/chatMicrosite/images/brandLogoImage';
import type {BrandLogoQueryResult} from 'microsites/core/chatMicrosite/images/brandLogoImage';
import type {BrandLogoResource} from 'microsites/core/chatMicrosite/types/imageResources';

export const useBrandLogoImage = (): BrandLogoResource => {
  const data = useStaticQuery<BrandLogoQueryResult>(graphql`
    query ChatiwiBrandLogoImage {
      file(sourceInstanceName: {eq: "chatiwiBrandAssets"}, name: {eq: "logo-square"}, extension: {eq: "png"}) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, formats: [PNG], width: 64, height: 64, quality: 100, backgroundColor: "#00000000")
        }
      }
    }
  `);

  return resolveBrandLogoResource(data);
};
